import service from "@hybird/core/request";
import url from "@hybird/device/request";
import {BeginSealDeviceMethodInterceptor} from "@hybird/device/interceptor/beginSeal/core";
import {DeviceBeginSealType, DeviceEvent} from "@hybird/core/device/protocol";

export class RemoteBeginSealInterceptor extends BeginSealDeviceMethodInterceptor {

  async equipmentLock(proceed, self, {
    sendEquipmentLock, upload, success, complete, message, fail, timeout
  } = {}) {
    sendEquipmentLock = sendEquipmentLock ? sendEquipmentLock : async () => {
      let documentRemoteId;
      // if (self.deviceProtocol.deviceConnectProvide.connectType === 2) {
      //   const result = await service.putForm(url.remoteLock, {
      //     number: this.deviceInfo.number
      //   });
      //
      //   documentRemoteId = result.data
      // } else {
      const result = await service.putForm(url.blueRemoteLock, {
        number: this.deviceInfo.number,
        model: self.deviceProtocol.deviceConnectProvide.connectType === 2 ? 2 : 1
      });

      documentRemoteId = result.data
      // }

      self.deviceProtocol.emit(DeviceEvent.EQUIPMENT_LOCK, {documentRemoteId});

      return {
        documentRemoteId
      }
    }
    const result = await proceed({
      sendEquipmentLock, upload, success, complete, message, fail, timeout
    });

    const documentRemoteId = result.documentRemoteId;

    const remoteUpload = async ({fileId, from, data = {}}) => {
      return await service.post(url.remote, {
        documentId: this.deviceInfo.documentId,
        sealId: this.deviceInfo.sealId,
        fileId: fileId,
        deviceId: this.deviceInfo.number,
        documentRemoteId: documentRemoteId,
        from: from,
        ...data,
      })
    }


    result.upload = result.upload ? result.upload.andThen(remoteUpload) : remoteUpload

    if (result.listen) {
      result.upload = result.upload.andThen((res) => {
        result.listen();
        return res;
      });
    }

    return result;
  }

  isSupport(self) {
    return self.option.remote === DeviceBeginSealType.remote;
  }
}
